import { QueryClient } from "@tanstack/react-query";

/**
 * QueryClient da aplicação.
 *
 * `refetchOnWindowFocus: false` é deliberado: as grelhas deste produto têm
 * 40 a 60 colunas e milhares de linhas. Refazer a query cada vez que o
 * utilizador volta ao separador é caro e, pior, faz saltar a posição de scroll
 * no meio de uma edição.
 *
 * A invalidação é explícita — quem escreve invalida o que mudou.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
});
